import { IMaterial } from '../utils/entities/interface';
import { Pagination } from './booking';
import { get, post, put } from './https';

interface MaterialListResponse {
  status: boolean;
  data: IMaterial[];
  count: number;
  pagination: Pagination;
}

const GETMaterial = async ({
  page = 1,
  limit = 25,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}): Promise<MaterialListResponse> => {
  let url = `/api/v1/admin/material/list?limit=${limit}&page=${page}`;

  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  if (sortField && sortField !== 'name') {
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    url += `&sortOrder=${sortOrder}`;
  }

  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch material');
  }
};

const CreateMaterial = async ({
  name,
  unit,
  rate,
  status,
}: {
  name: string;
  unit: string;
  rate: string;
  status: string;
}): Promise<any> => {
  const payload = {
    name,
    unit,
    rate,
    status,
  };

  const response = await post('/api/v1/admin/material/create', payload);

  if (response.status === 201) {
    return response;
  } else {
    throw new Error(response.statusText || 'Failed to add material');
  }
};

const EditMaterial = async ({
  name,
  unit,
  rate,
  status,
  materialId,
}: {
  name: string;
  unit: string;
  rate: string;
  status: string;
  materialId: string;
}): Promise<any> => {
  const payload = {
    name,
    unit,
    rate,
    status,
    materialId,
  };

  const response = await put('/api/v1/admin/material/edit', payload);
  console.log('response', response);

  if (response.status) {
    return response;
  } else {
    throw new Error(response.statusText || 'Failed to edit material');
  }
};

export { GETMaterial, CreateMaterial, EditMaterial };
